<template>
  <div class="post-block-style">
    <div class="post-content">
      <h2 class="post-title">
        <a :href="`${url}/articles/${article.oid}/${article.slug}`" target="_blank" v-if="url">{{ article.title }}</a>
        <router-link :to="{ name: 'ArticlePage', params: { slug: article.slug, id: article.oid } }" v-else>
          {{ article.title }}
        </router-link>
      </h2>
    </div>
    <p>{{ article.short_description }}</p>
  </div>
</template>

<script>
  export default {
    name: 'SmallArticlePreview',
    props: {
      article: { type: Object, required: true },
      url: { type: String },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/elements/SmallArticlePreview.vue